class DenominatorTable {
  constructor(denoTbl) {
    this.denoTbl = denoTbl
    this.calcEl = document.querySelector('.calculator')
    this.sendAmtArr = denoTbl.querySelectorAll('td:nth-child(odd)') // get elements having send amounts
    this.receiveAmtArr = denoTbl.querySelectorAll('td:nth-child(even)') // get elements to be populated with receive amounts
    this.denoTblInViewChecked = false
    this.denoTable = denoTbl.querySelector("#denoTable");
    this.spinner = denoTbl.querySelector("#spinner");
    this.checkCurrencyConverter = /\/currency-converter\/.+\.html$/.test(window.location.pathname)
    let hrefSplit = window.location.pathname.split('-')
    this.sendToCurrency = hrefSplit[hrefSplit.length - 2] && hrefSplit[hrefSplit.length - 2].toUpperCase()

    this.init()
  }

  init() {
    this.calcEl = this.calcEl ? this.calcEl : this.denoTbl
    this.denoTbl.classList.remove('d-none')
    this.denoTable.setAttribute('hidden', '');

    this.setSendToCountry()
    this.setReqPayload()

    let isDenoTblInViewport = () => {
      if (!this.denoTblInViewChecked) { // throttled the events
        this.denoTblInViewChecked = true
        setTimeout(() => {
          if ((this.denoTbl.getBoundingClientRect().top <= window.innerHeight && this.denoTbl.getBoundingClientRect().bottom >= 0)) { // check is elem visible
            this.callCatalogApi()
            window.removeEventListener("scroll", isDenoTblInViewport)
            window.removeEventListener("resize", isDenoTblInViewport)
            window.removeEventListener("load", isDenoTblInViewport)
          }
          this.denoTblInViewChecked = false
        }, 200)
      }
    }
    isDenoTblInViewport = isDenoTblInViewport.bind(this)
    window.addEventListener("scroll", isDenoTblInViewport)
    window.addEventListener("resize", isDenoTblInViewport)
    window.addEventListener("load", isDenoTblInViewport)
  }

  setSendToCountry() {
    if (this.checkCurrencyConverter && this.sendToCurrency) {
      this.sendToCountry = (() => {
        const currencyCodeElement = document.querySelector(`span[title=${this.sendToCurrency.toUpperCase()}]`)
        const countryCode = currencyCodeElement && currencyCodeElement.getAttribute('data-countrycode')
        if (countryCode) {
          return countryCode
        } else { // TODO: remove this block once countrycode is made mandatory in wp
          for (let code in ISO_CODES_COUNTRIES_CURRENCIES) {
            if (ISO_CODES_COUNTRIES_CURRENCIES[code] === this.sendToCurrency) return code
          }
        }
      })()
    } else {
      // if non currency converter page get sendToCountry from denoTbl attributes
      this.sendToCountry = this.denoTbl.getAttribute('send-to-country')
      this.sendToCurrency = this.denoTbl.getAttribute('send-to-currency')
    }
  }

  setReqPayload() {
    this.reqPayload = {
      currency: this.calcEl.getAttribute('data-currency') || denoTbl.getAttribute('data-currency'),
      country: this.calcEl.getAttribute('data-country'),
      funds_in: this.calcEl.getAttribute('data-fund-in'),
      fund_out_mnem: this.calcEl.getAttribute('data-fund-out-mnem'),
      host: this.calcEl.getAttribute('data-host'),
      sendAmount: '',
      sendToCurrency: ISO_CODES_COUNTRIES_CURRENCIES[this.sendToCountry],
      sendToCountry: this.sendToCountry
    }
  }

  callCatalogApi() {
    for (let i = 0; i < this.sendAmtArr.length; i++) {
      this.spinner.removeAttribute('hidden');
      this.reqPayload.sendAmount = parseInt(this.sendAmtArr[i].innerText).toFixed(2) // get send amount, eg 1.00 from 1 AUD
      const priceCatalogConfig = triggerPriceCatalog(this.reqPayload);
      // const that = this;
      httpRequest.post(priceCatalogConfig.url, priceCatalogConfig.reqPayload)
        .then((response) => {
          let {
            receiveAmount
          } = priceCatalogConfig.initApi(response)

          if (receiveAmount !== 0) {
            this.receiveAmtArr[i].innerText = `${receiveAmount.toFixed(2)} ${this.sendToCurrency}`;
            if (i == (this.sendAmtArr.length - 1)) {
              this.handleDenoTableShowHide();
            }
          } else if (receiveAmount == 0) {
            this.sendAmtArr[i].parentNode.parentNode.removeChild(this.sendAmtArr[i].parentNode);
            this.handleDenoTableShowHide();
          } else this.receiveAmtArr[i].parentNode.parentNode.removeChild(this.receiveAmtArr[i].parentNode)
        }).catch((err) => {
          if (i == 0) {
            this.denoTbl.setAttribute('hidden', '');
            this.spinner.setAttribute('hidden', '');
          }
        });
    }
  }

  handleDenoTableShowHide() {
    this.spinner.setAttribute('hidden', '');
    this.denoTable.removeAttribute('hidden');
  }
}


const denoTbl = document.getElementById('denoTblContainer')
const visibility = denoTbl && denoTbl.getAttribute('data-visibility') === 'true'
let enableDenominatorTable = sessionStorage.getItem('enableDenominatorTable')
enableDenominatorTable = enableDenominatorTable && enableDenominatorTable === 'true'
const showDenoOrNot = visibility ? visibility : enableDenominatorTable
if (denoTbl && showDenoOrNot) {
  const isCurrencyConverterMainPage = window.location.pathname.indexOf('currency-converter.html') !== -1
  !isCurrencyConverterMainPage && new DenominatorTable(denoTbl)
  sessionStorage.removeItem('enableDenominatorTable')
}
